import ImageCropper from './ImageCropper.lazy';
export default ImageCropper;